import { render, staticRenderFns } from "./checklist-item.vue?vue&type=template&id=5cb67fd8&"
import script from "./checklist-item.vue?vue&type=script&lang=js&"
export * from "./checklist-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports